import React, { useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import DisplayTrack from "./DisplayTrack";
import Controls from "./Controls";
import ProgressBar from "./ProgressBar";
import {
  faDownload, faMinus,
  faUpRightAndDownLeftFromCenter,
  faDownLeftAndUpRightToCenter
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import Loader from "./Loader";

function AudioPlayer({ track, setSticky, trackIndexSet, loading, interacted, setTrackIndex, handleText }) {
  const [currentTrack, setCurrentTrack] = useState(track[trackIndexSet]);
  const [timeProgress, setTimeProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const [isDocked, setIsDocked] = useState(true);

  const audioRef = useRef();
  const progressBarRef = useRef();

  useEffect(() => {
    if (interacted) setCurrentTrack(track[trackIndexSet]);
  }, [trackIndexSet, track, interacted]);

  const handleDownload = (url, id) => {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const urlObj = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = urlObj;
        link.setAttribute('download', id + '.mp3');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch(error => console.error('Error downloading audio file:', error));
  };

  const toggleDock = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsDocked(prev => !prev);
  };

  const containerStyle = isDocked
    ? {
      background: 'white',
      width: '100%',
      cursor: 'default',
      userSelect: 'none',
      border: '1px solid #ddd',
    }
    : {
      position: 'fixed',
      top: '85px',
      left: 'calc((100% - 500px) / 2)',
      zIndex: 9999,
      background: 'white',
      width: window.innerWidth > 655 ? '500px' : '100%',
      cursor: 'grab',
      userSelect: 'none',
      border: '1px solid #ddd',
    };

  const handleClassName = "drag-handle text-center py-1";
  const handleStyle = {
    background: '#f3f3f3',
    borderBottom: '1px solid #ddd',
    cursor: isDocked ? 'default' : 'grab',
    fontSize: '12px',
    color: '#555',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 8px'
  };

  const DockIcon = isDocked ? faUpRightAndDownLeftFromCenter : faDownLeftAndUpRightToCenter;
  const dockTitle = isDocked ? 'Float & drag' : 'Dock inline';

  const Inner = (
    <div className="audio-player rounded-3" style={containerStyle}>
      

      <div className="inner p-2">
        <ProgressBar {...{ progressBarRef, audioRef, timeProgress, duration }} />

        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex">
            <Controls
              {...{
                audioRef,
                progressBarRef,
                duration,
                setTimeProgress,
                track,
                interacted,
                trackIndexSet,
                setTrackIndex,
                setCurrentTrack,
              }}
            />
            <DisplayTrack
              {...{ interacted, currentTrack, audioRef, setDuration, progressBarRef, isDrag: isDocked }}
            />
          </div>

          <div className="d-flex flex-row">
            <span
              onClick={() => handleDownload(currentTrack.src, currentTrack.name)}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faDownload} />
            </span>

            <span
              className="history_audio"
              onClick={() => handleText(currentTrack)}
              style={{ cursor: 'pointer', margin: '0 10px' }}
            >
              {loading ? <Loader /> : <ChatBubbleIcon style={{ fontSize: 18 }} />}
            </span>
          </div>
        </div>
      </div>
    </div>
  );

  return isDocked ? (
    Inner
  ) : (
    <Draggable handle=".drag-handle" bounds="body" disabled={isDocked}>
      {Inner}
    </Draggable>
  );
}

export default AudioPlayer;
{/* <div className={handleClassName} style={handleStyle}>
        <span aria-hidden>⇅ Drag me</span>
        Dock/Undock button
        <div>
          <button
            onClick={() => setSticky(prev => !prev)}
            onMouseDown={(e) => e.stopPropagation()}
            title={dockTitle}
            aria-label={dockTitle}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 4
            }}
          >
            <FontAwesomeIcon icon={faMinus} />
          </button>
          <button
            onClick={toggleDock}
            onMouseDown={(e) => e.stopPropagation()}
            title={dockTitle}
            aria-label={dockTitle}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 4
            }}
          >
            <FontAwesomeIcon icon={DockIcon} />
          </button>

        </div>
      </div> */}